import type { ComponentType, SVGProps } from 'react';
import { styled } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

export interface IconProps extends SVGProps<SVGSVGElement> {
    width?: number | string;
    height?: number | string;
    size?: number | string;
    sx?: SxProps<Theme>;
}

const defaultSize = 24;

export default function createIcon(
    IconComponent: ComponentType<SVGProps<SVGSVGElement> & { title?: string }>,
): ComponentType<IconProps> {
    // if (import.meta.env.MODE === 'test') {
    //     // This makes as a Box containing the icon name, which, when using SVGR
    //     // i for example for icon "arrow-left.svg" name is "SvgArrowLeft".
    //     // Before, when using create-react-app + jest, the content would be
    //     // "arrow-left.svg", and we did not have to have tis construct for
    //     // the test environment
    //     //
    //     // noinspection UnnecessaryLocalVariableJS
    //     const TestComponent = (props: any) => (
    //         <Box component="svg" {...props}>
    //             {IconComponent.name}
    //         </Box>
    //     );
    //     return TestComponent;
    // }
    return styled(IconComponent, {
        shouldForwardProp: (prop) => !['size', 'sx'].includes(prop as string),
        name: IconComponent.name,
    })<IconProps>(({ onClick, size, width, height }) => ({
        width: size || width || defaultSize,
        height: size || height || defaultSize,
        minWidth: size || width || defaultSize, // In case there is not enough room, "width" is not enough, the SVG will shrink
        cursor: onClick ? 'pointer' : '',
        boxSizing: 'content-box',
    }));
    // return forwardRef<SVGSVGElement, IconProps>(function (props, forwardedRef) {
    //     const { size, width, height, onClick, ...otherProps } = props;
    //     const defaultSize = 24;
    //
    //     return (
    //         <Box
    //             ref={forwardedRef as any}
    //             component={IconComponent}
    //             style={{
    //                 cursor: onClick ? 'pointer' : '',
    //                 boxSizing: 'content-box',
    //             }}
    //             width={size || width || defaultSize}
    //             height={size || height || defaultSize}
    //             onClick={onClick}
    //             {...otherProps}
    //         />
    //     );
    // });
}
